<template>
  <footer class="page-footer footer">
      <div v-if="event" class="container text-center">
          <p>
            Contact a member of the events team <a href="tel:01992 374100">01992 374100</a>
          </p>
          <p>THANK YOU FOR ATTENDING THE {{ event.name.toUpperCase() }} SUMMIT</p>
      </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: mapState(['event']),
}
</script>
